import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "fw-semibold text-primary-dark",
  "data-test-ref": "multi-factor-auth-nav-interrupt-modal-header"
}
const _hoisted_2 = {
  class: "modal-body p-0",
  "data-test-ref": "multi-factor-auth-nav-interrupt-modal-body"
}
const _hoisted_3 = {
  class: "d-flex justify-content-end w-100",
  "data-test-ref": "multi-factor-auth-nav-interrupt-modal-footer"
}

import { ref, watch } from 'vue';
import { useI18n } from '@/i18n';


const __default__ = {
    compatConfig: {
        COMPONENT_V_MODEL: false,
    },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'multi-factor-auth-nav-interupt',
  props: {
    modelValue: {
        type: Boolean,
        default: false,
    },
},
  emits: ['update:modelValue', 'stayOnPage', 'leavePage'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();

/*-----*\
| Props |
\*-----*/



/*-----*\
| Emits |
\*-----*/



/*----*\
| Data |
\*----*/

const showModal = ref(false);

/*--------*\
| Watchers |
\*--------*/

watch(
    () => props.modelValue,
    (value) => {
        showModal.value = value;
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    size: "lg",
    visible: showModal.value,
    "ok-only": "",
    scrollable: "",
    "data-test-ref": "multi-factor-auth-nav-interrupt-modal-container",
    onShown: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', true)))
  }, {
    "modal-title": _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('mfa.leavingThisPage.modalTitle')), 1 /* TEXT */)
    ]),
    "modal-footer": _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_button, {
          variant: "outline-primary mr-2",
          "data-test-ref": "multi-factor-auth-code-stay-page",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('stayOnPage', true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('mfa.leavingThisPage.stay')), 1 /* TEXT */)
          ], undefined, true),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_b_button, {
          variant: "primary",
          "data-test-ref": "multi-factor-auth-code-leave-page",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('leavePage', true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('mfa.leavingThisPage.leave')), 1 /* TEXT */)
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('mfa.leavingThisPage.modalBody')), 1 /* TEXT */)
      ])
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible"]))
}
}

})